
const SoundManagerEvent = {};
export default SoundManagerEvent;

SoundManagerEvent.AUDIO_PAUSED = "AUDIO_PAUSED";
